import { render } from "./allDocComponent.vue?vue&type=template&id=e7f27cc4"
import script from "./allDocComponent.vue?vue&type=script&lang=js"
export * from "./allDocComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__